import posthog from 'posthog-js';
import { useEffect } from 'react';

export const usePostHogInit = () => {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host:
        process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',

      person_profiles: 'always',
      defaults: '2025-05-24',
      session_recording: {
        recordBody: true,
        recordCrossOriginIframes: true,
        recordHeaders: true,
      },
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') posthog.debug();
      },
    });
  }, []);
};
